import * as Sentry from "@sentry/react";

let parentMessage = {
	callback: null,
	url: null,
};

export const messenger = {
	postMessage: (message) => {
		if (window.parent.length === 0) return;

		let data = {
			//debug:true,
			...message,
		};
		console.log("postMessage", parentMessage, data);

		if (parentMessage.url && parentMessage.url.origin) {
			window.parent.postMessage(data, parentMessage.url.origin);
			return;
		}

		// unsure which origin is loading our frame, send event to wildcard origin
		window.parent.postMessage(data, "*");
	},
	init: (utilityConfig, callback) => {
		parentMessage.callback = (event) => {
			const whitelistOrigins = utilityConfig.parentIframeDomains;
			parentMessage.url = new URL(event.origin);

			if (!whitelistOrigins.find((host) => host === parentMessage.url.hostname)) {
				console.error("received message from unknown origin");
				Sentry.captureException(new Error("received message from unknown origin"), {
					extra: {
						origin: event.origin,
					},
				});
				return;
			}

			callback(event.data);
		};

		window.addEventListener("message", parentMessage.callback);

		messenger.postMessage({
			type: "loaded",
		});
	},
	clear: (callback) => {
		window.removeEventListener("message", parentMessage.callback);
	},
};
